import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import React, { useEffect, useState } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Alteration from "./components/Alteration";
import Checkout from "./components/Checkout";
import ItemDetail from "./components/ItemDetail";
import KnowMore from "./components/KnowMore";
import PerfectFit from "./components/PerfectFit";
import PincodeScreen from "./components/PincodeScreen";
import PlanScreen from "./components/PlanScreen";
import GiftCard from "./components/GiftCard";
import Products from "./components/Products";
import StaffLogin from "./components/StaffLogin";
import SweaterScreen from "./components/SweaterScreen";
import JeansScreen from "./components/JeansScreen";
import Thankyou from "./components/Thankyou";
import TypeSelectionScreen from "./components/TypeSelectionScreen";
import { installBfCacheGuard } from "./utils/kioskSession";
import { isSignedIn } from "./utils/staffAuth";
import FxryToaster from "./components/FxryToaster";

function App() {
  // Shared-device safety: a checkout page resurrected from the back/forward
  // cache (e.g. Back pressed on the thank-you page) is wiped and restarted.
  useEffect(() => installBfCacheGuard(), []);

  // The whole app is behind the staff login, not just the payment step. This
  // is a counter device, every screen on it is a staff screen, and the token
  // is what the Terminal calls send — so there is no useful state to be in
  // where someone is halfway through an order without one. It survives the
  // between-customers wipe (utils/kioskSession.js), so signing in is a
  // once-a-month thing.
  const [signedIn, setSignedIn] = useState(() => isSignedIn());
  if (!signedIn) {
    return <StaffLogin onSignedIn={() => setSignedIn(true)} />;
  }

  const appearance = {
    theme: "stripe",
  };
  // sessionStorage.getItem returns literal null when the key is missing —
  // e.g. a fully-discounted order never sets paymentIntentId, and a fresh
  // kiosk session has nothing stored yet. Passing clientSecret: null into
  // Stripe's Elements throws synchronously (IntegrationError) with no
  // error boundary to catch it, which is why the page went blank. Only
  // include clientSecret when it's a real string.
  const storedClientSecret = sessionStorage.getItem("paymentIntentId");
  const options = {
    ...(storedClientSecret ? { clientSecret: storedClientSecret } : {}),
    appearance,
  };

  // loadStripe throws on an empty key, which takes down every route — run
  // without Stripe (payments disabled) when no key is configured.
  const stripePromise = process.env.REACT_APP_STRIPE_API_KEY
    ? loadStripe(process.env.REACT_APP_STRIPE_API_KEY)
    : null;

  return (
    <Router>
      <Routes>
        {/* <Route path="/*" element={<UnderConstruction />} /> */}

        <Route path="/" element={<TypeSelectionScreen />} />
        <Route path="/zipcode" element={<PincodeScreen />} />
        <Route path="/types" element={<TypeSelectionScreen />} />
        <Route path="/plan" element={<PlanScreen />} />
        <Route path="/sweater" element={<SweaterScreen />} />
        <Route path="/jeans" element={<JeansScreen />} />
        <Route path="/alteration" element={<Alteration />} />
        <Route path="/perfect-fit" element={<PerfectFit />} />
        <Route path="/know-more" element={<KnowMore />} />
        <Route path="/item-detail" element={<ItemDetail />} />
        <Route path="/checkout" element={<Checkout />} />
        {/* Retail products: their own small sale, no garment or order. */}
        <Route path="/products" element={<Products />} />
        <Route path="/gift-card" element={<GiftCard />} />
        <Route
          path="/thankyou"
          element={
            <Elements options={options} stripe={stripePromise}>
              <Thankyou />
            </Elements>
          }
        />
      </Routes>
      <FxryToaster />
    </Router>
  );
}

export default App;
